module.exports = __webpack_public_path__ + "img/ycp.19d62ca6.png";